import {API_ENDPOINT, AUTH_HEADERS, X_AUTHORIZATION} from "../../../util/constants";
import {RSAA} from "redux-api-middleware";
import * as types from "../../types/index";
import {handleUnauthorizedAccess} from "../../../util/utility";

export function getHomeContent(token, api_token, query, filter_by, content_type, sort_by, page, width, height, broadcaster_id,only_subscribed_content = false) {

    let endpoint = `${API_ENDPOINT}/home?`;
    let headers = {
        ...AUTH_HEADERS
    };
    if(api_token !== null){
        endpoint += `api_token=${api_token}&`;
        headers = {
            ...AUTH_HEADERS,
            Authorization: `Bearer ${token}`
        }
    }

    if(query !== ""){
        endpoint += `query=${query}&`;
    }

    if(broadcaster_id !== null){
        endpoint += `broadcaster_id=${broadcaster_id}&`;
    }

   if(only_subscribed_content){
       endpoint += `filter_by=${filter_by}&content_type=${content_type}&sort_by=${sort_by}&page=${page}&width=${width}&height=${height}&only_subscribed_content=${only_subscribed_content}`;
   }else{
       endpoint += `filter_by=${filter_by}&content_type=${content_type}&sort_by=${sort_by}&page=${page}&width=${width}&height=${height}`;
   }

    endpoint += `&with_picture=true`;

    if (token === null || api_token === null) {
        headers = {
            ...AUTH_HEADERS
        };
    }
    return {
        [RSAA]: {
            endpoint: endpoint,
            method: 'GET',
            headers: headers,
            types: [types.GET_MY_CONTENT_REQUEST, types.GET_MY_CONTENT_RECEIVE, {
                type: types.GET_MY_CONTENT_FAILURE,
                meta: (action, state, res) => {
                    return handleUnauthorizedAccess(action, state, res);
                }
            }]
        }
    }
}

export const resetHomeContent = () => ({
    type: types.RESET_GET_MY_CONTENT,
    payload: null
});


/**
 * GET Video details
 * @param token
 * @param api_token
 * @param id
 * @returns {{}}
 */
export function getVideoDetailsById(token, api_token, id) {

    let endpoint = `${API_ENDPOINT}/viewer/clipstore/video/${id}`;
    let headers = {
        ...AUTH_HEADERS
    };

    if(api_token !== null){
        endpoint += `?api_token=${api_token}`;
        headers = {
            ...AUTH_HEADERS,
            Authorization: `Bearer ${token}`
        }
    }


    return {
        [RSAA]: {
            endpoint: endpoint,
            method: 'GET',
            headers: headers,
            types: [types.GET_VIDEO_DETAILS_REQUEST, types.GET_VIDEO_DETAILS_RECEIVE, {
                type: types.GET_VIDEO_DETAILS_FAILURE,
                meta: (action, state, res) => {
                    return handleUnauthorizedAccess(action, state, res);
                }
            }]
        }
    }
}

export const resetGetVideoDetailsById = () => ({
    type: types.RESET_GET_VIDEO_DETAILS,
    payload: null
});

/**
 * GET Picture details
 * @param token
 * @param api_token
 * @param id
 * @returns {{}}
 */
export function getPictureDetailsById(token, api_token, id) {

    let endpoint = `${API_ENDPOINT}/viewer/clipstore/picture/${id}`;
    let headers = {
        ...AUTH_HEADERS
    };

    if(api_token !== null){
        endpoint += `?api_token=${api_token}`;
        headers = {
            ...AUTH_HEADERS,
            Authorization: `Bearer ${token}`
        }
    }


    return {
        [RSAA]: {
            endpoint: endpoint,
            method: 'GET',
            headers: headers,
            types: [types.GET_PICTURE_DETAILS_REQUEST, types.GET_PICTURE_DETAILS_RECEIVE, {
                type: types.GET_PICTURE_DETAILS_FAILURE,
                meta: (action, state, res) => {
                    return handleUnauthorizedAccess(action, state, res);
                }
            }]
        }
    }
}

export const resetGetPictureDetailsById = () => ({
    type: types.RESET_GET_PICTURE_DETAILS,
    payload: null
});

/**
 * GET Gallery details
 * @param token
 * @param api_token
 * @param id
 * @returns {{}}
 */
export function getGalleryDetailsById(token, api_token, id) {

    let endpoint = `${API_ENDPOINT}/viewer/clipstore/gallery/${id}`;
    let headers = {
        ...AUTH_HEADERS
    };

    if(api_token !== null){
        endpoint += `?api_token=${api_token}`;
        headers = {
            ...AUTH_HEADERS,
            Authorization: `Bearer ${token}`
        }
    }

    return {
        [RSAA]: {
            endpoint: endpoint,
            method: 'GET',
            headers: headers,
            types: [types.GET_GALLERY_DETAILS_REQUEST, types.GET_GALLERY_DETAILS_RECEIVE, {
                type: types.GET_GALLERY_DETAILS_FAILURE,
                meta: (action, state, res) => {
                    return handleUnauthorizedAccess(action, state, res);
                }
            }]
        }
    }
}

export const resetGetGalleryDetailsById = () => ({
    type: types.RESET_GET_GALLERY_DETAILS,
    payload: null
});

export function getHistory(token, api_token,width,height, filter_by, sort_by, page) {

    let endpoint = `${API_ENDPOINT}/viewer/clipstore/history?`;
    let headers = {
        ...AUTH_HEADERS
    };

    if(api_token !== null){
        endpoint += `api_token=${api_token}&`;
        headers = {
            ...AUTH_HEADERS,
            Authorization: `Bearer ${token}`
        }
    }

    endpoint += `filter_by=${filter_by}&sort_by=${sort_by}&page=${page}&width=${width}&height=${height}`;

    return {
        [RSAA]: {
            endpoint: endpoint,
            method: 'GET',
            headers: headers,
            types: [types.GET_MY_HISTORY_OR_PURCHASE_CONTENT_REQUEST, types.GET_MY_HISTORY_OR_PURCHASE_CONTENT_RECEIVE, {
                type: types.GET_MY_HISTORY_OR_PURCHASE_CONTENT_FAILURE,
                meta: (action, state, res) => {
                    return handleUnauthorizedAccess(action, state, res);
                }
            }]
        }
    }
}

export const resetMyHistory = () => ({
    type: types.RESET_GET_MY_HISTORY_OR_PURCHASE_CONTENT,
    payload: null
});